export default __webpack_public_path__ + "81f1eca1748aa5bb1203a31a2f2f6d95.svg";